function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 62C3.58172 62 0 65.5817 0 70V203H206V70C206 65.5817 202.418 62 198 62H8ZM41 77C38.7909 77 37 78.7909 37 81V93C37 95.2091 38.7909 97 41 97H166C168.209 97 170 95.2091 170 93V81C170 78.7909 168.209 77 166 77H41Z",
  fill: "url(#paint0_linear_20015976_52874)"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  y: 62,
  width: 206,
  height: 51,
  rx: 8,
  fill: "url(#paint1_linear_20015976_52874)"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 37,
  y: 77,
  width: 133,
  height: 20,
  rx: 4,
  fill: "url(#paint2_linear_20015976_52874)"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_20015976_52874)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M110 76.5C110 76.667 109.999 76.8336 109.996 77C109.999 77.1664 110 77.333 110 77.5C110 84.8633 107.474 91.6364 103.24 97H53.7597C49.5264 91.6364 47 84.8633 47 77.5C47 77.333 47.0013 77.1664 47.0039 77C47.0013 76.8336 47 76.667 47 76.5C47 59.103 61.103 45 78.5 45C95.897 45 110 59.103 110 76.5Z",
  fill: "#717883"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.0021 97H103.998C107.773 91.8055 110 85.4128 110 78.5C110 61.103 95.897 47 78.5 47C61.103 47 47 61.103 47 78.5C47 85.4128 49.2268 91.8055 53.0021 97ZM91.1296 96L84.5469 85.7143H94V81.8286H63V85.7143H72.4531L65.8704 96H70.7691L78.5 83.9238L86.2309 96H91.1296ZM94 78.0571V74.1714H84.7383L91.2444 64H86.3074L78.5 76.2667L70.6926 64H65.7556L72.2617 74.1714H63V78.0952L94 78.0571Z",
  fill: "url(#paint3_linear_20015976_52874)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M84.5469 85.7143L91.1296 96H86.2309L78.5 83.9238L70.7691 96H65.8704L72.4531 85.7143H63V81.8286H94V85.7143H84.5469ZM94 74.1714V78.0571L63 78.0952V74.1714H72.2617L65.7556 64H70.6926L78.5 76.2667L86.3074 64H91.2444L84.7383 74.1714H94Z",
  fill: "#111827"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_20015976_52874)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M165 35.5C165 35.667 164.999 35.8336 164.996 36C164.999 36.1664 165 36.333 165 36.5C165 43.8633 162.474 50.6364 158.24 56H108.76C104.526 50.6364 102 43.8633 102 36.5C102 36.333 102.001 36.1664 102.004 36C102.001 35.8336 102 35.667 102 35.5C102 18.103 116.103 4 133.5 4C150.897 4 165 18.103 165 35.5Z",
  fill: "#717883"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M133.5 69C150.897 69 165 54.897 165 37.5C165 20.103 150.897 6 133.5 6C116.103 6 102 20.103 102 37.5C102 54.897 116.103 69 133.5 69ZM115.628 49.0115C116.173 49.8545 116.776 50.6583 117.433 51.4168L131.353 37.4982L117.433 23.5797C116.776 24.338 116.173 25.1414 115.628 25.9838L127.144 37.4982L115.628 49.0115ZM113 31.8582C113.29 30.7992 113.663 29.7647 114.114 28.764L122.85 37.4982L114.114 46.2325C113.663 45.2317 113.29 44.1972 113 43.1383L118.641 37.4982L113 31.8582ZM119.58 53.5679L133.501 39.6493L147.42 53.5679C146.662 54.2255 145.858 54.8284 145.015 55.3721L133.501 43.8577L121.985 55.3721C121.142 54.8284 120.338 54.2255 119.58 53.5679ZM142.233 56.8838L142.236 56.887V56.8823C142.235 56.8828 142.234 56.8833 142.233 56.8838ZM142.233 56.8838L133.499 48.1516L124.764 56.8858C125.765 57.3372 126.8 57.7097 127.859 58L133.499 52.3599L139.141 58C140.199 57.7084 141.233 57.3352 142.233 56.8838ZM147.42 21.4321L133.501 35.3507L119.58 21.4321C120.338 20.7753 121.142 20.1727 121.985 19.6291L133.501 31.1423L145.015 19.6291C145.858 20.1727 146.662 20.7753 147.42 21.4321ZM154 43.1383C153.71 44.1973 153.337 45.2318 152.886 46.2325L144.15 37.4982L152.886 28.7628C153.337 29.764 153.71 30.7989 154 31.8582L148.359 37.4982L154 43.1383ZM151.372 25.9838L139.856 37.4982L151.376 49.0115C150.832 49.8545 150.229 50.6583 149.572 51.4168L135.652 37.4982L149.567 23.5797C150.224 24.3378 150.827 25.1411 151.372 25.9838ZM142.236 18.1142L133.499 26.8484L124.764 18.1142C125.765 17.6633 126.8 17.2908 127.859 17L133.499 22.6401L139.141 17C140.2 17.2903 141.235 17.6628 142.236 18.1142Z",
  fill: "url(#paint4_linear_20015976_52874)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.433 51.4168C116.776 50.6583 116.173 49.8545 115.628 49.0115L127.144 37.4982L115.628 25.9838C116.173 25.1414 116.776 24.338 117.433 23.5797L131.353 37.4982L117.433 51.4168ZM114.114 28.764C113.663 29.7647 113.29 30.7992 113 31.8582L118.641 37.4982L113 43.1383C113.29 44.1972 113.663 45.2317 114.114 46.2325L122.85 37.4982L114.114 28.764ZM133.501 39.6493L119.58 53.5679C120.338 54.2255 121.142 54.8284 121.985 55.3721L133.501 43.8577L145.015 55.3721C145.858 54.8284 146.662 54.2255 147.42 53.5679L133.501 39.6493ZM142.236 56.887L133.499 48.1516L124.764 56.8858C125.765 57.3372 126.8 57.7097 127.859 58L133.499 52.3599L139.141 58C140.2 57.7081 141.235 57.3344 142.236 56.8823V56.887ZM133.501 35.3507L147.42 21.4321C146.662 20.7753 145.858 20.1727 145.015 19.6291L133.501 31.1423L121.985 19.6291C121.142 20.1727 120.338 20.7753 119.58 21.4321L133.501 35.3507ZM152.886 46.2325C153.337 45.2318 153.71 44.1973 154 43.1383L148.359 37.4982L154 31.8582C153.71 30.7989 153.337 29.764 152.886 28.7628L144.15 37.4982L152.886 46.2325ZM139.856 37.4982L151.372 25.9838C150.827 25.1411 150.224 24.3378 149.567 23.5797L135.652 37.4982L149.572 51.4168C150.229 50.6583 150.832 49.8545 151.376 49.0115L139.856 37.4982ZM133.499 26.8484L142.236 18.1142C141.235 17.6628 140.2 17.2903 139.141 17L133.499 22.6401L127.859 17C126.8 17.2908 125.765 17.6633 124.764 18.1142L133.499 26.8484Z",
  fill: "#111827"
}));

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_20015976_52874",
  x: 39,
  y: 41,
  width: 79,
  height: 68,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_20015976_52874"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_20015976_52874",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_20015976_52874",
  x: 94,
  y: 0,
  width: 79,
  height: 81,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_20015976_52874"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_20015976_52874",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_20015976_52874",
  x1: 0,
  y1: 95.5,
  x2: 206,
  y2: 95.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#31394B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0364583,
  stopColor: "#232B3C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#19202E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_20015976_52874",
  x1: 103,
  y1: 62,
  x2: 103,
  y2: 113,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#444C59"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2B3341"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_20015976_52874",
  x1: 103.5,
  y1: 77,
  x2: 103.5,
  y2: 97,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#222E46"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#111827"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_20015976_52874",
  x1: 78.5,
  y1: 47,
  x2: 78.5,
  y2: 97,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#515C6D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.791667,
  stopColor: "#313C4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#111926"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_20015976_52874",
  x1: 133.5,
  y1: 6,
  x2: 133.5,
  y2: 69,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#515C6D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#283344"
})));

function SvgDepositBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 151,
    viewBox: "0 0 206 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositBg);
export default __webpack_public_path__ + "static/media/depositBg.3aca7887285c2454bc4a8bd6c20c06c5.svg";
export { ForwardRef as ReactComponent };